import { PublicApiClient } from '@/services/PublicApiClient.js'

export default {
   getOrderByHash(hash) {
    return PublicApiClient.get(`orders/${hash}`)
      .then((response) => {
        return response
      })
      .catch((err) => {
        throw err
      })
  }
}
